import axios from "axios";
import { normIso } from "./format";

const isLocal = ["localhost", "127.0.0.1"].includes(window.location.hostname);

// آدرس API: متغیر REACT_APP_API_URL، وگرنه روی لوکال پورت ۴۰۰۰ و در سرور مسیر /api
export const API_BASE = (
  !isLocal ? "https://api.hse-charak.ir" : "http://localhost:4000"
).replace(/\/$/, "");

const api = axios.create({ baseURL: API_BASE, timeout: 20000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// فیلدهای تاریخ (…Date و date) همیشه به YYYY-MM-DD تبدیل شوند، حتی اگر سرور ISO کامل بفرستد
const DATE_KEY = /(Date|^date|^today)$/;
const fixDates = (o) => {
  if (Array.isArray(o)) return o.forEach(fixDates);
  if (!o || typeof o !== "object") return;
  for (const k of Object.keys(o)) {
    const v = o[k];
    if (
      typeof v === "string" &&
      DATE_KEY.test(k) &&
      /^\d{4}-\d{2}-\d{2}[T ]/.test(v)
    )
      o[k] = normIso(v);
    else if (v && typeof v === "object") fixDates(v);
  }
};

api.interceptors.response.use(
  (r) => {
    if (r.data && typeof r.data === "object") fixDates(r.data);
    return r;
  },
  (error) => {
    if (
      error.response?.status === 401 &&
      !error.config?.url?.startsWith("/auth/login")
    ) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (window.location.pathname !== "/login")
        window.location.assign("/login");
    }
    return Promise.reject(error);
  },
);

export const errMsg = (err, fallback = "خطایی رخ داد. دوباره تلاش کنید.") => {
  if (!err.response) return "خطا در ارتباط با سرور. اتصال را بررسی کنید.";
  return err.response.data?.error || fallback;
};

/** آدرس تصویر عمومی (لوگو / عکس پرسنلی) */
export const publicImg = (dir, name) =>
  name ? `${API_BASE}/uploads/${dir}/${name}` : null;

/** باز کردن فایل محافظت‌شده (با توکن) در تب جدید */
export async function openFile(path) {
  const w = window.open("", "_blank");
  try {
    const { data } = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    if (w) w.location.href = url;
    else window.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    if (w) w.close();
    throw e;
  }
}

export default api;
